export * from './shouldCostLibrary'

// for aggrid table where dynamic pagination is implemented
export const tableDefaultColDef = {
    filter: false,
    sortable: false,
    suppressMenu: true,
    resizable: true,
  }
